import watermark from "./watermark.js";

const install = function(Vue): void {
  Vue.directive("watermark", watermark);
};
// tslint:disable-next-line
watermark["install"] = install;
export default watermark as any;
